import React from "react";
import { useSelector } from "react-redux";
import { Placeholder } from "semantic-ui-react";

const LoadingLine = ({
  className,
  children,
  commonLoading,
  customInverted,
}) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return loadingStatus || commonLoading ? (
    <Placeholder
      inverted={customInverted === 1 ? false : isDarkMode}
      className={`mt-[12px] h-[7px] flex items-end rounded-full ${className} `}
    >
      <Placeholder.Image />
    </Placeholder>
  ) : (
    children
  );
};

export default LoadingLine;
